import React from 'react';
import TopWidgetPanelTitle from './TopWidgetPanelTitle';
import TopWidgetPanelContainer from './TopWidgetPanelContainer';

const TopWidgetPanelDesktop = ({ data }) => {
  return (
    <>
      <TopWidgetPanelTitle />
      <TopWidgetPanelContainer data={data} />
    </>
  );
};


export default TopWidgetPanelDesktop;
